import { Add, Close, Dashboard, Delete, Logout, Search } from "@mui/icons-material";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Button, Col, DropdownItem, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import colors from "../../config/Colors.config";
import Swal from "sweetalert2";
import Tiempo from "../../tools/Tiempo.tool";
import ComponentsCSS from "../../assets/css/Components.css";
import { IconButton } from "@mui/material";
import Cookies from 'universal-cookie';
import DeviceConfig from "../../config/Device.config";
import Fecha from "../../tools/Fecha.tool";
import Block from "../../components/Block.component";
import Table, { TableColumn } from 'react-data-table-component';
import Aclaracion from "../../interfaces/Aclaracion.interface";
import iconGoogleDocs from "../../assets/icons/google-docs.png";
import UsuarioModel from "../../models/Usuario.model";
import AclaracionService from "../../services/Aclaracion.service";
import Response from "../../interfaces/Response.interface";
import SEPOMEXService from "../../services/SEPOMEX.service";
import { MedioAtencion, Estado, Localidad } from "../../interfaces/SEPOMEX.interface";
import Producto from "../../interfaces/Producto.interface";
import Causa from "../../interfaces/Causa.interface";
import Ciudad from "../../interfaces/Ciudad.interface";
import ConsultaService from "../../services/Consulta.service";
import Numero from "../../tools/Number.tool";
import AclaracionModel from "../../models/Alcaracion.model";

const cookies = new Cookies();

interface Trimestre { IdTrimestre: number, trimestre: string }
interface NA { index: number, label: string }

const AclaracionIndex: FC = () => {

    const [labelUltimaActualizacion, setLabelUltimaActualizacion] = useState<string>(Tiempo.getCurrentTimeFormat12Hour());
    const [isOpenModalAclaracion, setIsOpenModalAclaracion] = useState<boolean>(false);
    const [device, setDevice] = useState(DeviceConfig.getData());
    const [fechaInicial, setFechaInicial] = useState<string>(Fecha.getDateToDay());
    const [fechaFinal, setFechaFinal] = useState<string>(Fecha.getDateToDay());
    const [mediosAtencionLista, setMediosAtencion] = useState<MedioAtencion[]>([]);
    const [productosLita, setProductosLista] = useState<Producto[]>([]);
    const [causasLista, setCausaLista] = useState<Causa[]>([]);
    const [estadosLista, setEstadosLista] = useState<Estado[]>([]);
    const [ciudadesLista, setCiudadesLista] = useState<Ciudad[]>([]);
    const [localidadLista, setLocalidadLista] = useState<Localidad[]>([]);
    const [isOpenModalErrors, setIsOpenModalErrors] = useState<boolean>(false);

    const [aclaracionLista, setAclaracionLista] = useState<Aclaracion[]>([]);
    const [aclaracion, setAclaracion] = useState<Aclaracion>(AclaracionModel.getEstructura());
    const [arrayErrors, setArrayErrors] = useState<string[]>([]);

    const arrayStatus: string[] = ["", "Pendiente", "Concluido"];
    const lista: NA[] = [
        { index: 1, label: "UNE" },
        { index: 2, label: "Sucursal" },
        { index: 3, label: "Centro de atención telefónica" },
        { index: 4, label: "Oficinas de atención" },
    ]
    const listaTrimestre: Trimestre[] = [
        {
            IdTrimestre: 1,
            trimestre: "1er Trimestre (1 de enero al 31 de marzo)",
        },
        {
            IdTrimestre: 2,
            trimestre: "2do Trimestre (1 de abril al 30 de junio)",
        },
        {
            IdTrimestre: 3,
            trimestre: "3er Trimestre (1 de julio al 30 de septiembre)",
        },
        {
            IdTrimestre: 4,
            trimestre: "4to Trimestre (1 de octubre al 31 de diciembre)",
        },
    ]
    const columnsAclaracion: TableColumn<Aclaracion>[] = [
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FOLIO </Label>,
            cell: (aclaracion: Aclaracion) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{aclaracion.folioAtencion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > TIPO PERSONA </Label>,
            cell: (aclaracion: Aclaracion) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{aclaracion.tipoPersona === 1 ? "Física" : "Moral"}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > Estatus </Label>,
            cell: (aclaracion: Aclaracion) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{arrayStatus[aclaracion.estadoConPend]}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FECHA RECEPCIÓN </Label>,
            cell: (aclaracion: Aclaracion) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{Fecha.formatoSimple(aclaracion.fechaAclaracion)}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > MONETARIO </Label>,
            cell: (aclaracion: Aclaracion) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{aclaracion.monetario}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} >  </Label>,
            cell: (aclaracion: Aclaracion) =>
                <>
                    {/* --- */}
                    <IconButton
                        onClick={() => {
                            eliminarAclaracion(aclaracion);
                        }}
                    >
                        <Delete style={{ color: colors.rojo }} />
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            listarCausasProductosLista(aclaracion.productoServicio);
                            listarCiudades(aclaracion.entidadFederativa);
                            listarLocalidad(aclaracion.entidadFederativa, aclaracion.municipioAlcaldia);
                            setAclaracion(aclaracion);
                            setIsOpenModalAclaracion(true);
                        }}
                    >
                        <img style={{ width: 23 }} src={iconGoogleDocs} alt="/*-" />
                    </IconButton>
                </>,
        },
    ]

    useEffect(() => {
        cargarDatos();
        listarEstadosLista();
        getMediosAtencionLista();
        listarProductosLista();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeAclaracionData = (name: string, value: string | number): void => {
        setAclaracion((prev: Aclaracion) => ({ ...prev, [name]: value }));
    }


    const getMediosAtencionLista = async (): Promise<void> => {
        const response: Response = await SEPOMEXService.getMediosAtencionLista();
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const mediosAtencionLista: MedioAtencion[] = value;
            setMediosAtencion(mediosAtencionLista);
        }
    }

    const listarProductosLista = async (): Promise<void> => {
        const response: Response = await ConsultaService.listarProductos();
        if (response.error === true) {
            toast.error("Error");
        } else {
            const productosLista: Producto[] = response.data.value ?? [];
            setProductosLista(productosLista);
        }
    };

    const listarCausasProductosLista = async (IdProducto: string): Promise<void> => {
        const response: Response = await ConsultaService.causaListarProductos(IdProducto);
        if (response.error === true) {
            toast.error("Error");
        } else {
            const causasLista: Causa[] = response.data.value ?? [];
            setCausaLista(causasLista);
        }
    };

    const listarEstadosLista = async (): Promise<void> => {
        const response: Response = await SEPOMEXService.getEstadosLista();
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const estadosLista: Estado[] = value;
            setEstadosLista(estadosLista);
        }
    }

    const listarCiudades = async (IdEstado: number): Promise<void> => {
        const response: Response = await SEPOMEXService.getCiudadesLista(IdEstado);
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const ciudadesLista: Ciudad[] = value;
            setCiudadesLista(ciudadesLista);
        }
    }

    const listarLocalidad = async (IdEstado: number, IdCiudad: number): Promise<void> => {
        const response: Response = await SEPOMEXService.getLocalidadLista(IdEstado, IdCiudad);
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const localidadesLista: Localidad[] = value;
            setLocalidadLista(localidadesLista);
        }
    }

    const cargarDatos = async (): Promise<void> => {

        setDevice(DeviceConfig.getData());

        if (UsuarioModel.getToken().length > 0) {
            const fechaInicial: string = Fecha.getDateToDay();
            const fechaFinal: string = Fecha.getDateToDay();
            listarAclaraciones(fechaInicial, fechaFinal);
        } else {
            document.body.innerHTML = "<body></body>";
            Swal.fire({
                icon: "warning",
                title: "Acceso denegado",
                text: `Tienes que iniciar sesión para poder usar el sistema`,
                showConfirmButton: true,
                confirmButtonColor: colors.dorado01,
                confirmButtonText: "Ir al login",
                timerProgressBar: true,
                reverseButtons: true,
                timer: 10000
            }).then(async (response) => {
                if (response.isConfirmed) window.location.href = "/"
            });
            Tiempo.sleep(10).then(() => window.location.href = "/");
        }

    }

    const listarAclaraciones = async (fechaInicial: string, fechaFinal: string): Promise<void> => {
        const response: Response = await AclaracionService.listar(fechaInicial, fechaFinal);
        const { error } = response;
        if (error === false) {
            const { data: { value } } = response;
            const aclaracionLista: Aclaracion[] = value;
            setAclaracionLista(aclaracionLista);
            setLabelUltimaActualizacion(Tiempo.getCurrentTimeFormat12Hour());
        } else {
            toast.error("Error");
        }
    }

    const eliminarAclaracion = async (aclaracion: Aclaracion): Promise<void> => {

        Swal.fire({
            icon: "question",
            title: "Eliminar Aclaracion",
            text: `¿Estas seguro de eliminar esta Aclaracion con folio: ${aclaracion.folioAtencion}?`,
            showConfirmButton: true,
            confirmButtonColor: colors.rojo,
            showCancelButton: true,
            cancelButtonText: "No, Eliminar",
            confirmButtonText: "Si, Eliminar",
            timerProgressBar: true,
            reverseButtons: true,
        }).then(async (response) => {
            if (response.isConfirmed) {
                await AclaracionService.eliminar(aclaracion.IdAclaracion);
                // await REDECOServices.eliminarQueja(queja.quejasFolio);
                toast.success("Aclaracion eliminada");
                listarAclaraciones(fechaInicial, fechaFinal);
            }
        });
    };

    const enviarAclaracion = async (): Promise<void> => {
        const { value, arrayErrors } = AclaracionModel.validar(aclaracion);
        if (value) {
            setIsOpenModalErrors(true);
            setArrayErrors(arrayErrors);
        } else {
            const response: Response = await AclaracionService.guardar(aclaracion);
            if (response.error) {
                toast.error("Error");
            } else {
                listarAclaraciones(fechaInicial, fechaFinal);
                toast.success("Reclamo guardado");
                setIsOpenModalAclaracion(false);
            }
        }
    }

    return (
        <section>
            <ToastContainer limit={3} position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            <Block height={70} />

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Col style={{ textAlign: "left" }} >
                    <Dashboard style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            window.location.href = "/reune/panel";
                        }}
                    >
                        Ir al Dashboard
                    </Label>
                </Col>
                <Col style={{ textAlign: "right" }} >
                    <Logout style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            Swal.fire({
                                icon: "question",
                                title: "Salir del Sistema",
                                text: `¿Estas seguro de que quieres salir del sistema?`,
                                showConfirmButton: true,
                                confirmButtonColor: colors.dorado01,
                                showCancelButton: true,
                                cancelButtonText: "No",
                                confirmButtonText: "Si",
                                timerProgressBar: true,
                                reverseButtons: true,
                                timer: 10000
                            }).then(async (response) => {
                                if (response.isConfirmed) {
                                    cookies.remove("usuario");
                                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                                }
                            });
                        }}
                    >
                        Salir del Sistema
                    </Label>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Col style={{ minWidth: "25%", width: "25%", maxWidth: "25%" }}  >
                    <FormGroup>
                        <Label style={{ color: colors.dorado01 }} >
                            Fecha Inicial
                        </Label>
                        <InputGroup>
                            <Input
                                id="fechaInicial"
                                value={fechaInicial}
                                max={fechaFinal}
                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                    setFechaInicial(value);
                                }}
                                style={{ ...ComponentsCSS.Input, marginTop: 0 }}
                                type="date"
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col style={{ minWidth: "25%", width: "25%", maxWidth: "25%" }}  >
                    <FormGroup>
                        <Label style={{ color: colors.dorado01 }} >
                            Fecha Final
                        </Label>
                        <InputGroup>
                            <Input
                                id="fechaFinal"
                                value={fechaFinal}
                                min={fechaInicial}
                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                    setFechaFinal(value);
                                }}
                                style={ComponentsCSS.Input}
                                type="date"
                            />
                            <InputGroupText
                                style={ComponentsCSS.InputGroupText}
                                onClick={() => {
                                    listarAclaraciones(fechaInicial, fechaFinal);
                                }}
                            >
                                <Search style={{ color: colors.dorado01 }} />
                            </InputGroupText>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col style={{ textAlign: "right", minWidth: "50%", width: "50%", maxWidth: "50%" }} >
                    <IconButton style={{ marginTop: 30 }} >
                        <Add
                            style={{ color: colors.dorado01 }}
                            onClick={() => {
                                setAclaracion(AclaracionModel.getEstructura());
                                setIsOpenModalAclaracion(true)
                            }}
                        />
                    </IconButton>
                    <IconButton
                        style={{ marginTop: 30, marginRight: 5 }}
                        onClick={() => {
                            listarAclaraciones(fechaInicial, fechaFinal);
                        }}
                    >
                        <Search style={{ color: colors.dorado01 }} />
                    </IconButton>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Label style={{ fontWeight: "bold", fontSize: 18, color: colors.dorado01 }} >
                    Lista de aclaraciones del {Fecha.formatDateToText(fechaInicial)} al {Fecha.formatDateToText(fechaFinal)}
                </Label>
            </Row>
            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Col>
                    <Label>
                        <i>Ultima actualización a las {labelUltimaActualizacion} <br />
                            Se listaron {aclaracionLista.length} consulta(s)</i>
                    </Label>
                </Col>
            </Row>
            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Table
                    columns={columnsAclaracion}
                    data={aclaracionLista}
                    noDataComponent={<Label style={{ fontWeight: "bold", fontSize: 26, color: colors.gris, marginTop: 50, textAlign: "center" }} >TABLA VACÍA</Label>}
                />
            </Row>

            <Modal
                isOpen={isOpenModalAclaracion}
                style={{ maxWidth: device.isDesktop ? "90%" : "100%", fontFamily: '"Fira Sans", sans-serif' }}
            >
                <ModalHeader
                    close={
                        <IconButton
                            onClick={() => setIsOpenModalAclaracion(false)}
                            style={{ backgroundColor: colors.blanco01, color: colors.dorado01 }}
                        >
                            <Close />
                        </IconButton>
                    }
                    style={{
                        backgroundColor: colors.dorado01
                    }}
                >
                    <Label style={{ color: colors.blanco01, fontSize: 24 }} >
                        DATOS PARA ENVIAR
                    </Label>
                </ModalHeader>
                <ModalBody style={{ minHeight: "70vh", maxHeight: "70vh", height: "70vh", overflowY: "auto" }} >
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "40%" : "100%", width: device.isDesktop ? "40%" : "100%", maxWidth: device.isDesktop ? "40%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Denominación o razón social
                                </Label>
                                <Input
                                    id="consulta.denominacion"
                                    value={aclaracion.denominacion}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "30%" : "100%", width: device.isDesktop ? "30%" : "100%", maxWidth: device.isDesktop ? "30%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Sector
                                </Label>
                                <Input
                                    id="consulta.sector"
                                    value={aclaracion.sector}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "30%" : "100%", width: device.isDesktop ? "30%" : "100%", maxWidth: device.isDesktop ? "30%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Trimestre a informar
                                </Label>
                                <Input
                                    id={"Aclaracion.trimestre"}
                                    value={aclaracion.trimestre}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        setAclaracion((prev: Aclaracion) => ({ ...prev, trimestre: Number(value) }));
                                    }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    {
                                        listaTrimestre.map((trimestre: Trimestre) => {
                                            return (<option value={trimestre.IdTrimestre}>{trimestre.trimestre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Número de Aclaracion
                                </Label>
                                <Input
                                    id={"Aclaracion.numero"}
                                    value={aclaracion.numero}
                                    type="text"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        value = Numero.soloNumero(value);
                                        onChangeAclaracionData("numero", Number(value));
                                    }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo, descuerdo a la disposición siempre el valor sera 1"}
                                    style={ComponentsCSS.Input}
                                >
                                    {
                                        listaTrimestre.map((trimestre: Trimestre) => {
                                            return (<option value={trimestre.IdTrimestre}>{trimestre.trimestre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Folio
                                </Label>
                                <Input
                                    id="Aclaracion.folioAtencion"
                                    value={aclaracion.folioAtencion}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("folioAtencion", value);
                                    }}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Estatus
                                </Label>
                                <Input
                                    id={"Aclaracion.estadoConPend"}
                                    value={aclaracion.estadoConPend}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("estadoConPend", Number(value));
                                    }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    <option value={1}>Pendiente</option>
                                    <option value={2}>Concluido</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de aclaracion
                                </Label>
                                < Input
                                    id={"Aclaracion.fechaAclaracion"}
                                    value={aclaracion.fechaAclaracion}
                                    type="date"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("fechaAclaracion", value);
                                    }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                    style={ComponentsCSS.Input}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de atención
                                </Label>
                                {
                                    Number(aclaracion.estadoConPend) === 2 &&
                                    < Input
                                        id={"Aclaracion.fechaAtencion"}
                                        value={aclaracion.fechaAtencion}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("fechaAtencion", value);
                                        }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                        style={ComponentsCSS.Input}
                                    />
                                }
                                {Number(aclaracion.estadoConPend) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(aclaracion.estadoConPend) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Medios de recepción o canal
                                </Label>
                                < Input
                                    id={"Aclaracion.medioRecepcionCanal"}
                                    value={aclaracion.medioRecepcionCanal}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("medioRecepcionCanal", Number(value));
                                    }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        mediosAtencionLista.map((value: MedioAtencion) => {
                                            return (<option value={value.IdMedioAtencion}>{value.nombre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Productos
                                </Label>
                                <Input
                                    id="Aclaracion.productoServicio"
                                    value={aclaracion.productoServicio}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("productoServicio", value);
                                        onChangeAclaracionData("causaMotivo", "0");
                                        listarCausasProductosLista(value);
                                        // const producto: Producto | undefined = productosLita.find((producto: Producto) => producto.IdProducto === value);                                        
                                        // if (producto) handleConsultaData("productoDescripcion", producto.producto);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        productosLita.map((value: Producto) => {
                                            return (<option value={value.IdProducto}>{value.producto}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "40%" : "100%", width: device.isDesktop ? "40%" : "100%", maxWidth: device.isDesktop ? "40%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Causa
                                </Label>
                                <Input
                                    id="Aclaracion.causaMotivo"
                                    value={aclaracion.causaMotivo}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("causaMotivo", value);
                                        // const causa: Causa | undefined = causasLista.find((causa: Causa) => causa.IdCausa === Number(value));
                                        // if (causa) handleConsultaData("causaDescripcion", causa.causa);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        causasLista.map((value: Causa) => {
                                            return (<option value={value.IdCausa}>{value.causa}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de Resolución
                                </Label>
                                {
                                    Number(aclaracion.estadoConPend) === 2 &&
                                    < Input
                                        id={"Aclaracion.fechaResolucion"}
                                        value={aclaracion.fechaResolucion}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("fechaResolucion", value);
                                        }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                        style={ComponentsCSS.Input}
                                    />
                                }
                                {Number(aclaracion.estadoConPend) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(aclaracion.estadoConPend) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de Atencion
                                </Label>
                                {
                                    Number(aclaracion.estadoConPend) === 2 &&
                                    < Input
                                        id={"Aclaracion.fechaNotifUsuario"}
                                        value={aclaracion.fechaNotifUsuario}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("fechaNotifUsuario", value);
                                        }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                        style={ComponentsCSS.Input}
                                    />
                                }
                                {Number(aclaracion.estadoConPend) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(aclaracion.estadoConPend) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Estado
                                </Label>
                                <Input
                                    id="Aclaracion.entidadFederativa"
                                    value={aclaracion.entidadFederativa}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("entidadFederativa", Number(value));
                                        onChangeAclaracionData("municipioAlcaldia", 0);
                                        listarCiudades(Number(value));
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        estadosLista.map((value: Estado) => {
                                            return (<option value={value.IdEstado}>{value.nombre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Código Postal
                                </Label>
                                <Input
                                    id="Aclaracion.codigoPostal"
                                    value={aclaracion.codigoPostal}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        if (value.length <= 5) onChangeAclaracionData("codigoPostal", Number(Numero.soloNumero(value)));
                                    }}
                                    type={"text"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Ciudad
                                </Label>
                                <Input
                                    id="Aclaracion.municipioAlcaldia"
                                    value={aclaracion.municipioAlcaldia}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("municipioAlcaldia", Number(value));
                                        listarLocalidad(aclaracion.entidadFederativa, Number(value));
                                        // const ciudad: Ciudad | undefined = ciudadesLista.find((ciudad: Ciudad) => ciudad.IdCiudad === Number(value));
                                        // if (ciudad) handleConsultaData("municipioDescripcion", ciudad.ciudad);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value="0">Seleccione una opción</option>
                                    {
                                        ciudadesLista.map((item: Ciudad) => {
                                            return (
                                                <option value={item.IdCiudad}>{item.ciudad}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Localidad
                                </Label>
                                <Input
                                    id="Aclaracion.localidad"
                                    value={aclaracion.localidad}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("localidad", value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value="0">Seleccione una opción</option>
                                    {
                                        localidadLista.map((item: Localidad) => {
                                            return (
                                                <option value={item.IdLocalidad}>{item.localidad}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Monetario
                                </Label>
                                <Input
                                    id="Aclaracion.monetario"
                                    value={aclaracion.monetario}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("monetario", value);
                                        if (value !== "SI") onChangeAclaracionData("montoReclamado", 0);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value="null">Seleccione una opción</option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Monto Reclamado
                                </Label>
                                {
                                    aclaracion.monetario === "SI" &&
                                    <InputGroup>
                                        <InputGroupText style={{ ...ComponentsCSS.Input, backgroundColor: "transparent" }}>
                                            $
                                        </InputGroupText>
                                        <Input
                                            id="Aclaracion.montoReclamado"
                                            value={aclaracion.montoReclamado}
                                            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                onChangeAclaracionData("montoReclamado", Number(Numero.soloNumero(value)));
                                            }}
                                            type={"text"}
                                            style={{ ...ComponentsCSS.Input }}
                                            disabled={aclaracion.IdAclaracion > 0}
                                        />
                                    </InputGroup>
                                }
                                {aclaracion.monetario === "null" && <><br /> <i>Seleccione si es monetario</i></>}
                                {aclaracion.monetario === "NO" && <><br /> <i>Esta dato no es necesario si no es monetario</i></>}
                            </FormGroup>
                        </Col>

                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    PORI
                                </Label>
                                <Input
                                    id="Aclaracion.pori"
                                    value={aclaracion.pori}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("pori", value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value="null">Seleccione una opción</option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Tipo de persona
                                </Label>
                                <Input
                                    id="Aclaracion.tipoPersona"
                                    value={aclaracion.tipoPersona}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeAclaracionData("tipoPersona", Number(value));
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={aclaracion.IdAclaracion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    <option value={1}>Persona Física</option>
                                    <option value={2}>Persona Moral</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >

                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Sexo
                                </Label>
                                {
                                    Number(aclaracion.tipoPersona) === 1 &&
                                    <Input
                                        id="Aclaracion.sexo"
                                        value={aclaracion.sexo}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("sexo", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                    >
                                        <option value={"null"}>Seleccione una opción</option>
                                        <option value={"H"}>Hombre</option>
                                        <option value={"M"}>Mujer</option>
                                    </Input>
                                }
                                {Number(aclaracion.tipoPersona) !== 1 && <><br /> <i>Solo si la persona es física</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Edad
                                </Label>
                                {
                                    Number(aclaracion.tipoPersona) === 1 &&
                                    <Input
                                        id="Aclaracion.edad"
                                        value={aclaracion.edad}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("edad", Number(Numero.soloNumero(value)));
                                        }}
                                        type={"text"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                    />
                                }
                                {Number(aclaracion.tipoPersona) !== 1 && <><br /> <i>Solo si la persona es física</i> </>}
                            </FormGroup>
                        </Col>

                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Nivel de atencion
                                </Label>
                                {
                                    Number(aclaracion.estadoConPend) === 2 &&
                                    <Input
                                        id="Aclaracion.nivelAtencion"
                                        value={aclaracion.nivelAtencion}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("nivelAtencion", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                    >
                                        <option value={0}>Seleccione una opción</option>
                                        {
                                            lista.map((item: NA) => {
                                                return (
                                                    <option value={item.index}>{item.label}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                }
                                {Number(aclaracion.estadoConPend) !== 2 && <><br /> <i>Solo si el estatus esta en concluido</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Folio asignado por la CONDUSEF
                                </Label>
                                {
                                    (Number(aclaracion.medioRecepcionCanal) === 6 || Number(aclaracion.medioRecepcionCanal) === 7) &&
                                    <Input
                                        id="Aclaracion.folioCondusef"
                                        value={aclaracion.folioCondusef}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("folioCondusef", value);
                                        }}
                                        type={"text"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                    />
                                }
                                {((Number(aclaracion.medioRecepcionCanal) !== 6) && (Number(aclaracion.medioRecepcionCanal) !== 7)) && <><br /> <i>Valor no requerido</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Reversa SIGE
                                </Label>
                                {
                                    Number(aclaracion.medioRecepcionCanal) === 6 &&
                                    <Input
                                        id="Aclaracion.reversa"
                                        value={aclaracion.reversa}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("reversa", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                    >
                                        <option value={0}>SI es revers SIEG <i>[Gestión electrónica]</i></option>
                                        <option value={1}>NO es revers SIEG <i>[Gestión electrónica]</i></option>
                                    </Input>
                                }
                                {Number(aclaracion.medioRecepcionCanal) !== 6 && <><br /> <i>Valor no requerido</i> </>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Operación en extranjero
                                </Label>
                                {
                                    Number(aclaracion.medioRecepcionCanal) === 6 &&
                                    <Input
                                        id="Aclaracion.reversa"
                                        value={aclaracion.reversa}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeAclaracionData("reversa", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={aclaracion.IdAclaracion > 0}
                                    >
                                        <option value={"NO"}>NO</option>
                                        <option value={"SI"}>SI</option>
                                    </Input>
                                }
                                {Number(aclaracion.medioRecepcionCanal) !== 6 && <><br /> <i>Valor no requerido</i> </>}
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {
                        aclaracion.IdAclaracion === 0 &&
                        <Button
                            style={{ backgroundColor: colors.blanco01, borderColor: colors.dorado01, color: colors.dorado01, fontWeight: "bold", boxShadow: "none" }}
                            onClick={() => {
                                enviarAclaracion();
                            }}
                        >
                            Enviar
                        </Button>
                    }
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={isOpenModalErrors}
                style={{ maxWidth: device.isDesktop ? "50%" : "100%", fontFamily: '"Fira Sans", sans-serif' }}
            >
                <ModalHeader
                    close={
                        <IconButton
                            onClick={() => setIsOpenModalErrors(false)}
                            style={{ backgroundColor: colors.blanco01, color: colors.dorado01 }}
                        >
                            <Close />
                        </IconButton>
                    }
                    style={{
                        backgroundColor: colors.dorado01
                    }}
                >
                    <Label style={{ color: colors.blanco01, fontSize: 24 }} >
                        ERRORES DETECTADOS
                    </Label>
                </ModalHeader>
                <ModalBody style={{ minHeight: "70vh", maxHeight: "70vh", height: "70vh", overflowY: "auto" }} >
                    {
                        arrayErrors.map((label: string, index: number) => {
                            return (
                                <>
                                    <Row style={{ marginLeft: 20, marginRight: 0 }} >
                                        <Col>
                                            <Label>
                                                {index + 1}{'.- '}{label}
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            )
                        })
                    }
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ backgroundColor: colors.blanco01, borderColor: colors.dorado01, color: colors.dorado01, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalErrors(false)}
                    >
                        Cerrar
                    </Button>

                </ModalFooter>
            </Modal>

        </section>
    );
};

export default AclaracionIndex;